import styles from './charts.module.css';

/** FROZEN bar-chart treatment (§15). Transcribed from the approved design. */

export interface BarChartProps {
  readonly label: string;
  readonly data: ReadonlyArray<readonly [string, number, number]>;
  readonly primaryLabel: string;
  readonly compareLabel: string;
  readonly summary?: string;
}

export function BarChart({ label, data, primaryLabel, compareLabel, summary }: BarChartProps) {
  const max = Math.max(...data.flatMap(([, a, b]) => [a, b]), 1);

  return (
    <div className={styles.chart}>
      <div className={styles.plot} role="img" aria-label={label}>
        {data.map(([month, primary, compare]) => (
          <div className={styles.group} key={month}>
            <div className={styles.pair}>
              <span
                className={`${styles.bar} ${styles.barPrimary}`}
                style={{ height: `${String((primary / max) * 100)}%` }}
              />
              <span
                className={`${styles.bar} ${styles.barCompare}`}
                style={{ height: `${String((compare / max) * 100)}%` }}
              />
            </div>
            <span className={styles.axisLabel}>{month}</span>
          </div>
        ))}
      </div>
      <div className={styles.legend}>
        <span className={styles.legendKey}>
          <span className={styles.legendSwatch} style={{ background: 'var(--color-brand-teal)' }} />
          {primaryLabel}
        </span>
        <span className={styles.legendKey}>
          <span
            className={styles.legendSwatch}
            style={{ background: 'var(--x-chart-series-compare)' }}
          />
          {compareLabel}
        </span>
        {summary !== undefined && <span className={styles.legendStat}>{summary}</span>}
      </div>
    </div>
  );
}
